import getCanvas from '../helpers/getCanvas';

const normalizeHiddenFields = (html) => {
  const canvas = getCanvas(html);
  const nonStandardFields = canvas.querySelectorAll('input[tabindex="-1"]');

  if (!nonStandardFields.length) {
    return html;
  }

  Array.from(nonStandardFields).forEach((field) => {
    field.setAttribute('type', 'hidden');
  });

  return canvas.innerHTML;
};

export default normalizeHiddenFields;



/** WEBPACK FOOTER **
 ** ./src/helpers/form/filters/factories/normalizeHiddenFields.js
 **/